
const ContactInfo = () => {
  return (
    <div className="space-y-8">
      <div className="bg-teal-50 rounded-lg p-8">
        <h3 className="text-2xl font-bold text-gray-900 mb-6">Get in Touch</h3>
        
        <div className="space-y-6">
          <div className="flex items-start space-x-4">
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-phone-line text-teal-600 text-xl"></i>
            </div>
            <div>
              <h4 className="font-semibold text-gray-900">Phone</h4>
              <p className="text-gray-600">+971 56 276 1272</p>
              <p className="text-sm text-gray-500">Available 24/7 for urgent inquiries</p>
            </div>
          </div>

          <div className="flex items-start space-x-4">
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-mail-line text-teal-600 text-xl"></i>
            </div>
            <div>
              <h4 className="font-semibold text-gray-900">Email</h4>
              <p className="text-gray-600">info@chemsolutionservice.live</p>
              <p className="text-sm text-gray-500">Response within 24 hours</p>
            </div>
          </div>

          <div className="flex items-start space-x-4">
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-time-line text-teal-600 text-xl"></i>
            </div>
            <div>
              <h4 className="font-semibold text-gray-900">Response Time</h4>
              <p className="text-gray-600">Normal: 24-48 hours</p>
              <p className="text-gray-600">Urgent: Within 4 hours</p>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-lg p-8">
        <h3 className="text-xl font-bold text-gray-900 mb-4">Our Expert Team</h3>
        <div className="space-y-4">
          <div className="flex items-center space-x-4">
            <img 
              src="https://public.readdy.ai/ai/img_res/0f540aa31da7ae8295c473829b57c835.jpg"
              alt="Chemical Engineer"
              className="w-16 h-16 rounded-full object-cover object-top"
            />
            <div>
              <h4 className="font-semibold text-gray-900">Dr. Ahmed Hassan</h4>
              <p className="text-sm text-gray-600">Senior Chemical Engineer</p>
              <p className="text-xs text-gray-500">15+ years in oilfield chemicals</p>
            </div>
          </div>
          
          <div className="flex items-center space-x-4">
            <img 
              src="https://readdy.ai/api/search-image?query=Professional%20female%20chemical%20engineer%20with%20Golden%20Black%20branding%2C%20experienced%20technical%20specialist%20in%20modern%20laboratory%20environment%2C%20confident%20expert%20in%20safety%20gear%20with%20chemical%20equipment%20background&width=80&height=80&seq=expert-2&orientation=squarish"
              alt="Process Engineer"
              className="w-16 h-16 rounded-full object-cover object-top"
            />
            <div>
              <h4 className="font-semibold text-gray-900">Dr. Sarah Al-Mansouri</h4>
              <p className="text-sm text-gray-600">Process Engineer</p>
              <p className="text-xs text-gray-500">12+ years in production chemicals</p>
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <img 
              src="https://readdy.ai/api/search-image?query=Professional%20chemical%20research%20scientist%20with%20Golden%20Black%20company%20logo%2C%20experienced%20technical%20expert%20in%20advanced%20laboratory%20setting%2C%20confident%20specialist%20with%20modern%20chemical%20analysis%20equipment&width=80&height=80&seq=expert-3&orientation=squarish"
              alt="Research Scientist"
              className="w-16 h-16 rounded-full object-cover object-top"
            />
            <div>
              <h4 className="font-semibold text-gray-900">Dr. Mohammed Al-Rashid</h4>
              <p className="text-sm text-gray-600">Research Scientist</p>
              <p className="text-xs text-gray-500">10+ years in EOR chemicals</p>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-gray-50 rounded-lg p-6">
        <h3 className="text-lg font-bold text-gray-900 mb-3">What to Include in Your Message</h3>
        <ul className="space-y-2 text-sm text-gray-600">
          <li className="flex items-start space-x-2">
            <i className="ri-check-line text-teal-600 mt-0.5"></i>
            <span>Specific chemical requirements or challenges</span>
          </li>
          <li className="flex items-start space-x-2">
            <i className="ri-check-line text-teal-600 mt-0.5"></i>
            <span>Operating conditions (temperature, pressure, pH)</span>
          </li>
          <li className="flex items-start space-x-2">
            <i className="ri-check-line text-teal-600 mt-0.5"></i>
            <span>Application area (drilling, production, EOR, etc.)</span>
          </li>
          <li className="flex items-start space-x-2">
            <i className="ri-check-line text-teal-600 mt-0.5"></i>
            <span>Volume requirements and timeline</span>
          </li>
          <li className="flex items-start space-x-2">
            <i className="ri-check-line text-teal-600 mt-0.5"></i>
            <span>Any specific performance criteria</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default ContactInfo;
